export const projectsData = [
  
    {
    title: "Website - Portfolio",
    image: "/img/projects.jpeg",
    fallbackIcon: "fa-laptop-code",
    skills: ["ReactApp", "Git"],
    description: "Main projects page",
    links: [
      { url: "https://cvreactapp.vercel.app", icon: "fas fa-external-link-alt", text: "Demo" },
      { url: "https://github.com/comnsense/Projects", icon: "fab fa-github", text: "GitHub" }
    ]
  },
  {
    title: "TarotApp",
    image: "/img/reacttarot.jpg",
    fallbackIcon: "fa-gamepad",
    skills: ["React", "Web Application"],
    description: "Interactive Tarot Card Guide - Your digital companion in the world of Tarot.",
    links: [
      { url: "https://react-tarot-sandy.vercel.app", icon: "fas fa-external-link-alt", text: "Demo" },
      { url: "https://github.com/comnsense/reactTarot", icon: "fab fa-github", text: "GitHub" }
    ]
  },
  {
    title: "Ecommerce Project",
    image: "/img/Ecommerce.jpg",
    fallbackIcon: "fa-brain",
    skills: ["Next.js", "Strapi", "REST API", "TypeScript"],
    description: "EComm-CS is an online store created as a portfolio project. Uses Next.js for frontend and Strapi for backend. Deployed on Vercel.",
    links: [
      { url: "https://e-comm-cs.vercel.app", icon: "fas fa-external-link-alt", text: "Demo" },
      { url: "https://github.com/comnsense/EComm-CS", icon: "fab fa-github", text: "GitHub" }
    ]
  },
  {
    title: "CV - Resume",
    image: "/img/cv-resume.jpeg",
    fallbackIcon: "fa-laptop-code",
    skills: [ "GitHub Pages", "JavaScript", "Responsive"],
    description: "Main portfolio website with CV and projects",
    links: [
      { url: "https://comnsense.github.io/", icon: "fas fa-external-link-alt", text: "Overview" },
      { url: "https://github.com/comnsense/comnsense.github.io", icon: "fab fa-github", text: "GitHub" }
    ]
  },
{
    title: "Development of an App for Mental Health Support",
    image: "/img/thesis.jpg",
    fallbackIcon: "fa-brain",
    skills: ["Node.js", "Express", "React", "NLP", "AI"],
    description: "Using AI and NLP for analyzing user queries and generating adaptive responses.",
    links: [
      { url: "https://comnsense.github.io/Annex/thesis.pdf", icon: "fas fa-file-pdf", text: "Thesis" },
      { url: "https://github.com/comnsense/ai-mental-assistant-app", icon: "fab fa-github", text: "GitHub" }
    ]
  },
  {
    title: "TIC-TAC-TOE Game",
    image: "/img/tic-tac-toe.gif",
    fallbackIcon: "fa-gamepad",
    skills: ["HTML5", "CSS3", "JavaScript"],
    links: [
      { url: "https://comnsense.github.io/Tic-Tac-Toe-Game", icon: "fas fa-external-link-alt", text: "Demo" },
      { url: "https://github.com/comnsense/Tic-Tac-Toe-Game", icon: "fab fa-github", text: "GitHub" }
    ]
  },
  {
    title: "Halloween Website",
    image: "/img/HelloweenApp.jpg",
    fallbackIcon: "fa-pumpkin",
    skills: ["HTML5", "CSS3", "Responsive"],
    description: "Web-Design project with thematic design.",
    links: [
      { url: "https://comnsense.github.io/Projects/Halloween%20Website", icon: "fas fa-external-link-alt", text: "Demo" },
      { url: "https://github.com/comnsense/Projects/tree/main/Halloween%20Website", icon: "fab fa-github", text: "GitHub" }
    ]
  },
  {
    title: "Blog Theme - MumblrTum",
    image: "/img/tumblr-theme.jpeg",
    fallbackIcon: "fa-blog",
    skills: ["HTML5", "CSS3", "JavaScript"],
    description: "Custom blog theme",
    links: [
      { url: "https://mumblrtum.tumblr.com/", icon: "fas fa-external-link-alt", text: "Overview" },
      { url: "https://github.com/comnsense/mumblrtum", icon: "fab fa-github", text: "GitHub" }
    ]
  },

    {
    title: "Application Bulgarian Chinese Chamber for Industrial Development (BCCID)",
    fallbackIcon: "fa-building",
    skills: ["AppSheet", "Data visualization"],
    details: [
      "Manage members, customers, and payments for services",
      "Process optimization through data visualization"
    ],
    links: [
      { url: "https://www.appsheet.com/start/5e82fa28-7112-40f0-ab58-2fba90efe623?platform=desktop", icon: "fas fa-external-link-alt", text: "AppSheet" }
    ]
  }
];